<template>
  <div></div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'playLink',
  data () {
    return {}
  },
  computed: {
    ...mapState(['isShowAd'])
  },
  created () {
    const query = {
      id: this.$route.query.id
    }
    if (!this.isShowAd) {
      query.ad_show = 'no'
    }
    this.$router.replace({
      path: '/playVideo',
      query: query
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/playLink.vue